export default __webpack_public_path__ + "alberta-grouped-list.9a0987f54b2794c3db52.svg";